import { string, object } from 'yup';

export const financialReportValidationSchema = object().shape({
    year_end: string().required('Financial Year End is required'),
    language: string().required('Language is required'),
});
